module.exports = __webpack_public_path__ + "assets/mam1.jpg?4b491722f295e8aca2adeb34788722c9";